/** Regelversion 11: neue und aufgelöste Parteien, Landtage. */
import { useS } from '../../store/game';
import { Panel, Sw } from '../../components/ui';
import { PARTIES } from '../../content/parties';
import { STATES } from '../../content/states';
import { pxOn, typeName } from '../../engine/parties11';
import { PN, PA } from '../../engine/rules';
import { dateLabel, de } from '../../engine/util';

/** Kleines Abzeichen „neu“ für Parteien, die es bei der letzten Wahl noch nicht gab. */
export function NewTag({ id, prev }: { id: string; prev?: any }) {
  const S = useS(); const P = (S as any).px;
  if (!P?.parties?.[id] || (prev && prev.share?.[id] != null)) return null;
  return <span className="tag warn" style={{ marginLeft: 6 }}>neu</span>;
}

/** Reiter „Stimmung“: Parteienlandschaft. */
export function PartiesPanel() {
  const S = useS(); const P = (S as any).px; if (!pxOn()) return null;
  const neu = Object.keys(P?.parties || {}), gone = Object.keys(P?.gone || {});
  const lt = (k: string) => Object.keys(P?.lt || {}).filter((s) => P.lt[s].in.includes(k));
  return (
    <Panel title="Parteienlandschaft" aside={neu.length ? `${neu.length} neue ${neu.length === 1 ? 'Partei' : 'Parteien'}` : 'keine Neugründungen'} className="pxbox">
      <span className="sub">Entdeckt die Bevölkerung eine Lücke, die keine Partei im Bundestag füllt, oder verbiegt sich eine Partei in der Regierung, können neue Parteien entstehen. Wer zweimal an der 5-%-Hürde scheitert und in keinem Landtag mehr sitzt, löst sich auf.</span>
      {neu.length > 0 && <div className="pxlist">{neu.map((k) => { const X = PARTIES[k] || P.parties[k], l = lt(k); return (
        <div key={k} className="pxrow"><b><Sw id={k} />{X.n} ({X.a}) <span className="sub">· {typeName(k)}{P.gone[k] != null ? ' · aufgelöst' : ` · gegründet ${dateLabel(P.born[k])}`}</span></b>
          <span className="sub">{X.d}</span>
          {P.gone[k] == null && <span className="sub">Umfrage etwa {de(X.base, 1)} % · {l.length ? `im Landtag: ${l.map((s) => STATES[s].n).join(', ')}` : 'in keinem Landtag'}</span>}</div>); })}</div>}
      {gone.filter((k) => !P.parties[k]).map((k) => <span key={k} className="sub"><Sw id={k} />{PN(k)} hat sich {dateLabel(P.gone[k])} aufgelöst.</span>)}
    </Panel>
  );
}

/** Landtag eines Landes (Karte). */
export function LandtagLine({ id }: { id: string }) {
  const S = useS(); const L = (S as any).px?.lt?.[id]; if (!L) return null;
  const list = L.in.slice().sort((a: string, b: string) => (L.sh[b] || 0) - (L.sh[a] || 0));
  return <span className="sub">Im Landtag: {list.map((k: string, i: number) => <span key={k}>{i ? ', ' : ''}<Sw id={k} />{PA(k)} {de(L.sh[k] || 0, 0)} %</span>)}</span>;
}
